// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"a5789877","549":"3cbed094","562":"6477adde"}[chunkId] + ".chunk.js";
};